'use es6';

import { Record, Set as ImmutableSet } from 'immutable';
import GeolocationRecord from './GeolocationRecord';
import { FBGeolocationTypes } from 'AdsUI/lib/Constants';
import { getCountryName } from 'AdsUI/lib/Utils';
import I18n from 'I18n';
export default new Record({
  id: null,
  name: null,
  targeting: null,
  approximate_count_upper_bound: -1,
  approximate_count_lower_bound: -1,

  getLocations() {
    const {
      cities = [],
      subcities = [],
      countries = [],
      country_groups = [],
      places = [],
      regions = [],
      geo_markets = [],
      custom_locations = []
    } = this.targeting.geo_locations || {};
    return ImmutableSet([...cities, ...subcities].map(city => new GeolocationRecord({
      key: city.key,
      name: city.name,
      type: FBGeolocationTypes.CITY,
      countryName: getCountryName(city.country),
      countryCode: city.country,
      regionName: city.region,
      regionId: city.region_id
    })).concat([...places, ...regions].map(place => new GeolocationRecord({
      key: place.key,
      name: place.name,
      type: FBGeolocationTypes.REGION,
      countryName: getCountryName(place.country),
      countryCode: place.country
    }))).concat(countries.map(countryCode => new GeolocationRecord({
      key: countryCode,
      name: getCountryName(countryCode),
      type: FBGeolocationTypes.COUNTRY,
      countryCode
    }))).concat(geo_markets.map(geoMarket => new GeolocationRecord({
      key: geoMarket.key,
      name: geoMarket.name,
      type: FBGeolocationTypes.GEO_MARKET,
      countryName: getCountryName(geoMarket.country),
      countryCode: geoMarket.country
    }))).concat(country_groups.map(countryGroup => new GeolocationRecord({
      key: countryGroup,
      name: I18n.text(`creation.targeting.countryGroup.${countryGroup}`),
      type: FBGeolocationTypes.COUNTRY_GROUP
    }))).concat(custom_locations.filter(({
      latitude
    }) => latitude !== undefined).map(({
      address_string,
      latitude,
      longitude
    }) => new GeolocationRecord({
      key: `${longitude}, ${latitude}`,
      name: I18n.text('creation.targeting.customLocation', {
        address: address_string ? `${address_string}, ` : '',
        latitude,
        longitude
      }),
      type: FBGeolocationTypes.CUSTOM_LOCATION
    }))));
  }

});